// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
    width: 100%;
}

.mat-elevation-z8 {
    box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0), 0 0px 0px 0px rgba(0, 0, 0, 0), 0 0px 0px 0px rgba(0, 0, 0, 0);
}

.kt-wizard-v2 .kt-wizard-v2__wrapper .kt-form {
   
     padding:0px; 
}
.kt-wizard-v2[_ngcontent-cca-c4] .kt-wizard-v2__wrapper[_ngcontent-cca-c4] .kt-form[_ngcontent-cca-c4] {
    width: 100%;
    padding: 0px;
}
.kt-portlet {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    box-shadow: 0px 0px 0px 0px rgba(82, 63, 105, 0.05); 
    background-color: #ffffff;
    margin-bottom: 20px;
    border-radius: 4px;
}
td,tr,th{text-align: center;}
.localizationList{
    display: flex;
    justify-content: center;
}
.input{
    margin-right: 5px;
    width: 200px;
}
.submit{width:50px; }`, "",{"version":3,"sources":["webpack://./src/app/views/translation/translation.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,0GAA0G;AAC9G;;AAEA;;KAEK,WAAW;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,mDAAmD;IACnD,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;AACA,SAAS,kBAAkB,CAAC;AAC5B;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,YAAY;AAChB;AACA,QAAQ,UAAU,EAAE","sourcesContent":["table {\r\n    width: 100%;\r\n}\r\n\r\n.mat-elevation-z8 {\r\n    box-shadow: 0 0px 0px 0px rgba(0, 0, 0, 0), 0 0px 0px 0px rgba(0, 0, 0, 0), 0 0px 0px 0px rgba(0, 0, 0, 0);\r\n}\r\n\r\n.kt-wizard-v2 .kt-wizard-v2__wrapper .kt-form {\r\n   \r\n     padding:0px; \r\n}\r\n.kt-wizard-v2[_ngcontent-cca-c4] .kt-wizard-v2__wrapper[_ngcontent-cca-c4] .kt-form[_ngcontent-cca-c4] {\r\n    width: 100%;\r\n    padding: 0px;\r\n}\r\n.kt-portlet {\r\n    display: flex;\r\n    flex-grow: 1;\r\n    flex-direction: column;\r\n    box-shadow: 0px 0px 0px 0px rgba(82, 63, 105, 0.05); \r\n    background-color: #ffffff;\r\n    margin-bottom: 20px;\r\n    border-radius: 4px;\r\n}\r\ntd,tr,th{text-align: center;}\r\n.localizationList{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.input{\r\n    margin-right: 5px;\r\n    width: 200px;\r\n}\r\n.submit{width:50px; }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
